<div class="bgcolor-tg flex justify-between items-center px-5 py-2.5">
  <div class="user">
    <mat-icon class="icon-30" fontIcon="account_circle"></mat-icon>
    <span>Olá, {{ user.name ? user.name : user.perfil }}!</span>
    @if (checkAmbient()) {
      <div
        style="background-color: #320373; padding: 2px 8px; border-radius: 20px"
      >
        <strong>Ambiente {{ ambient }}.</strong>
      </div>
    }
  </div>
  <div class="flex justify-end items-end gap-5">
    <div class="style-date">{{ currentDateTime }}</div>
    <div class="btn-logout" matTooltip="Alterar senha">
      <mat-icon class="icon-30" fontIcon="key" (click)="changePassword()"></mat-icon>
    </div>
    <div class="btn-logout" matTooltip="Sair">
      <mat-icon class="icon-30" fontIcon="logout" (click)="logout()"></mat-icon>
    </div>
  </div>
</div>
